<template>
    <div :class="buttonClasses">
        <router-link v-if="link_type === 'page'"
                     class="link-cta"
                     :class="{light: link_light}"
                     :to="routerLink">
            <div class="button-copy">
                {{ text }}
            </div>
            <div class="arrow-container">
                <arrow />
            </div>
        </router-link>
        <a v-else
           :rel="target_blank ? 'noopener':''"
           class="link-cta"
           :class="{light: link_light}"
           :href="urlLink"
           :target="target_blank ? '_blank':''"
           @click="scrollToAnchor">
            <div class="button-copy">
                {{ text }}
            </div>
            <div class="arrow-container">
                <arrow />
            </div>
        </a>
    </div>

</template>

<script>
    import Arrow from '../svgs/Arrow'

    export default {
        name: "ButtonLink",
        components: { Arrow },
        props: {
            button_style: {
                type: String,
                default: 'block'
            },
            link_light: {
                type: Boolean,
                default: false,
            },
            link_type: {
                type: String,
                default: 'page'
            },
            text: {
                type: String,
                default: 'Click here'
            },
            url: {
                type: String,
                default: ''
            },
            page: {
                type: String,
                default: ''
            },
            anchor: {
                type: String,
                default: ''
            },
            target_blank: {
                type: Boolean,
                default: false
            },
            arrowOn: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            buttonClasses() {
                return `button ${this.button_style}`
            },
            routerLink() {
                return this.url.replace(location.origin, '')
            },
            urlLink() {
                return this.link_type === 'anchor' ? `#${this.anchor}`:this.page;
            },
            routerLink() {
                return this.page.replace(location.origin, '')
            }
        },
        methods: {
            scrollToAnchor() {
                if (this.link_type === 'anchor') {
                    this.$scrollTo(`#${this.anchor}`, 500);
                }
            }
        },
    }
</script>

<style lang="scss" scoped>


    .link-cta{
        @include link-cta;

        .button-copy, .arrow-container{
            position: relative;
            z-index: 5;
        }

        .arrow-container{
            font-size: 20px;
        }
    }
</style>